import React from 'react';
import { CommonButton } from '@Components';
import { AADHAR_VERIFICATION } from '../../utils/constants';
import { ModalContainer } from './style';
import { BLUE_WARNING_ICON, CLOSE_POPUP_ICON } from '@Images';
import { IAadharNotLinkedModalProps } from '../../utils/interface';

const AadharNotLinkedModal: React.FC<IAadharNotLinkedModalProps> = (props) => {
  const { aadharNotLinked, setUpTransfer, gotIt, linkAadhar } = AADHAR_VERIFICATION;
  const { handleGotIt } = props;
  return (
    <ModalContainer
      containerMarginTop={32}
      buttonTopMargin={16}
      buttonWidth={418}
      height={362}
      width={450}
    >
      <div className="navigationContainer">
        <img className="closeButton" onClick={handleGotIt} src={CLOSE_POPUP_ICON} alt="close" />
      </div>
      <div className="modalBodyContainer">
        <div className="headerContainer">
          <div className="image-container">
            <img src={BLUE_WARNING_ICON} alt="logo" />
          </div>
          <p className="aadharNotLinked">{aadharNotLinked}</p>
          <p className="linkAadhar">{linkAadhar}</p>
          <p className="setUpTransfer">{setUpTransfer}</p>
        </div>
        <CommonButton onClick={handleGotIt} text={gotIt} width={418} />
      </div>
    </ModalContainer>
  );
};

export default AadharNotLinkedModal;
